<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { AvatarRoot } from 'reka-ui'
import { avatarVariant, type AvatarVariants } from '.'
import { cn } from '@/lib/utils'

const props = withDefaults(defineProps<{
  class?: HTMLAttributes['class']
  size?: AvatarVariants['size']
  shape?: AvatarVariants['shape']
  src?: string
  alt?: string
  fallback?: string
}>(), {
  size: 'sm',
  shape: 'circle',
})

/**
 * Generates initials from a name string
 * - For multiple words: takes first letter of first and second word
 * - For single word: takes first two letters
 * - For empty string: returns empty string
 */
const getInitials = (name?: string): string => {
  if (!name) return ''

  const parts = name.split(' ')
  if (parts.length > 1) {
    return (parts[0]?.[0] || '') + (parts[1]?.[0] || '')
  }

  return name.substring(0, 2)
}
</script>

<template>
  <AvatarRoot :class="cn(avatarVariant({ size, shape }), props.class)">
    <slot>
      <NuxtImg
        v-if="src"
        :src="src"
        :alt="alt"
      />
      <UiAvatarFallback v-else>
        {{ getInitials(fallback) }}
      </UiAvatarFallback>
    </slot>
  </AvatarRoot>
</template>
